import React from "react";
import JobList from "@presentation/components/job/JobList";

/**
 * Job list page where a list of all existing jobs and all their details can be displayed with filtering options.
 * @returns Functional component
 */
const JobListPage: React.FC = () => {
  return <JobList />;
};

export default JobListPage;
